const initialHistoryLength = parseInt(window.history.length, 10)
export default () => window.history.length - initialHistoryLength
